// extracted by mini-css-extract-plugin
module.exports = {"switchWrapper":"switchButton_switchWrapper__1mE6D"};